import React, { useState, useEffect } from 'react'
import { Modal, Box, Button } from '@mui/material'
import { DateRange } from 'react-date-range'
import 'react-date-range/dist/styles.css' // Main CSS
import 'react-date-range/dist/theme/default.css' // Theme CSS
import dayjs from 'dayjs'
import { X } from 'lucide-react'

const dateFormat = 'YYYY-MM-DD'

const DatePickerFromTo = ({
  setCheckInDate,
  setCheckOutDate,
  checkInDate,
  checkOutDate,
  open,
  holidayData,
  setOpen,
  changeDate,
  setChangeDate
}) => {
  const totalNights = parseInt(holidayData?.totalNights) || 1
  const [selectionRange, setSelectionRange] = useState({
    startDate: checkInDate ? new Date(checkInDate) : new Date(),
    endDate: checkOutDate
      ? new Date(checkOutDate)
      : new Date(new Date().setDate(new Date().getDate() + 1)),
    key: 'selection'
  })

  const [forceEndDateFocus, setForceEndDateFocus] = useState(false)

  // Sync state with parent when modal opens
  useEffect(() => {
    if (changeDate) {
      setSelectionRange({
        startDate: checkInDate ? new Date(checkInDate) : new Date(),
        endDate: checkOutDate
          ? new Date(checkOutDate)
          : new Date(new Date().setDate(new Date().getDate() + 1)),
        key: 'selection'
      })
    }
  }, [changeDate, checkInDate, checkOutDate])

  const handleSelect = ranges => {
    let newCheckIn = dayjs(ranges.selection.startDate)
    let newCheckOut = dayjs(ranges.selection.endDate)

    // Ensure check-out aligns with totalNights interval
    let nightsDiff = newCheckOut.diff(newCheckIn, 'days')

    if (nightsDiff % totalNights !== 0) {
      const nextMultiple = Math.ceil(nightsDiff / totalNights) * totalNights
      newCheckOut = newCheckIn.add(nextMultiple, 'days')
    }

    // Preserve existing startDate if user only changes endDate
    setSelectionRange(prevState => ({
      startDate: newCheckIn ? new Date(newCheckIn) : prevState.startDate,
      endDate: newCheckOut ? new Date(newCheckOut) : prevState.endDate,
      key: 'selection'
    }))

    // Ensure focus is always on endDate when startDate is already set
    if (selectionRange.startDate) {
      setForceEndDateFocus(true)
    }
  }

  const handleOk = () => {
    const startDate = dayjs(selectionRange.startDate)
    let endDate = dayjs(selectionRange.endDate)

    // ✅ If start and end are the same, add +1 day to endDate
    if (startDate.isSame(endDate, 'day')) {
      endDate = startDate.add(1, 'day')
    }
    setCheckInDate(startDate.format(dateFormat))
    setCheckOutDate(endDate.format(dateFormat))

    setOpen(false)
    setChangeDate(false)
  }

  const handleClear = () => {
    // setCheckInDate(null)
    // setCheckOutDate(null)
    setSelectionRange({
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection'
    })
    setForceEndDateFocus(false)
    // setChangeDate(false)
    // setForceEndDateFocus(false)
  }

  const handleClose = () => {
    setCheckInDate(null)
    setCheckOutDate(null)
    setSelectionRange({
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection'
    })
    setForceEndDateFocus(false)
    setChangeDate(false)
    setForceEndDateFocus(false)
  }

  const handleCloseModal = () => {
    setChangeDate(false)
  }

  return (
    <Modal
      open={changeDate}
      onClose={handleCloseModal}
      aria-labelledby='date-range-modal'
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <Box
        sx={{
          p: 3,
          backgroundColor: 'white',
          borderRadius: '10px',
          boxShadow: 24,
          position: 'relative'
        }}
      >
        <Box
          display='flex'
          justifyContent='end'
          sx={{ position: 'absolute', top: '0px', right: '0px' }}
        >
          <Button
            onClick={handleClose}
            sx={{ color: 'black', display: 'flex', justifyContent: 'end' }}
          >
            <X size={26} />
          </Button>
        </Box>
        <Box mt={3}>
          <DateRange
            ranges={[selectionRange]}
            onChange={handleSelect}
            minDate={new Date()} // Prevent past dates
            focusedRange={forceEndDateFocus ? [0, 1] : undefined} // Force focus on endDate
          />
          <Box mt={2} display='flex' justifyContent='space-between'>
            <Button
              onClick={handleClear}
              sx={{ border: '1px solid', color: '#6DC8BF' }}
            >
              Clear
            </Button>
            <Button
              onClick={handleOk}
              sx={{ backgroundColor: '#6DC8BF', color: '#ffffff' }}
            >
              Ok
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  )
}

export default DatePickerFromTo
